import { bl_fi_mst_branch_employee_link_RowClass } from "../../../dbschema/bl_fi_mst_branch_employee_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class EmployeeBranchLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_employee_link: bl_fi_mst_branch_employee_link_RowClass =
    new bl_fi_mst_branch_employee_link_RowClass();
}
